"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CalendarScheduleList = void 0;
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const useCallforward_1 = __importDefault(require("@opsbase/react-hooks/useCallforward"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const Card_1 = __importDefault(require("@opsbase/web-layout/Card"));
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical"));
const react_1 = __importStar(require("react"));
const calcPlaceLabel_1 = __importDefault(require("../helpers/calcPlaceLabel"));
const calcScheduleTitle_1 = __importDefault(require("../helpers/calcScheduleTitle"));
const useOpScheduleCalendar_1 = __importDefault(require("../OpScheduleCalendarController/useOpScheduleCalendar"));
const useOpScheduleCalendarActions_1 = __importDefault(require("../OpScheduleCalendarController/useOpScheduleCalendarActions"));
const useOpScheduleCalendarSelection_1 = __importDefault(require("../OpScheduleCalendarController/useOpScheduleCalendarSelection"));
const makeMyCardClasses = isSelected => ({
    root: {
        transition: 'background-color 0.3s, border-color 0.3s, color 0.3s',
        backgroundColor: isSelected ? lib_palette_1.default.secondary.main : lib_palette_1.default.LightBlue.main,
        border: `1px solid ${lib_palette_1.default.GreyBlue.main} !important`,
        color: isSelected
            ? `${lib_palette_1.default.secondary.contrastText} !important`
            : `${lib_palette_1.default.BlackCoral.main} !important`,
        boxShadow: isSelected ? `0 0 20px -4px ${lib_palette_1.default.BlackCoral.main}` : undefined,
    },
});
function CalendarScheduleList() {
    const { schedules } = (0, useOpScheduleCalendar_1.default)();
    const { selectedSchedule } = (0, useOpScheduleCalendarSelection_1.default)();
    const { doSelectSchedule } = (0, useOpScheduleCalendarActions_1.default)();
    const selectedId = selectedSchedule === null || selectedSchedule === void 0 ? void 0 : selectedSchedule.id;
    const sortedSchedules = (0, react_1.useMemo)(() => (schedules ? [...schedules].sort((a, b) => getSortScore(a) - getSortScore(b)) : []), [schedules]);
    const handleOnClick = (0, useCallforward_1.default)(v => () => doSelectSchedule(v), [doSelectSchedule]);
    const handleClear = (0, react_1.useCallback)(() => doSelectSchedule(undefined), [doSelectSchedule]);
    return (0, react_1.useMemo)(() => {
        return (react_1.default.createElement(Vertical_1.default, { gutter: true, scrollY: true, onClick: handleClear }, sortedSchedules.map(schedule => (react_1.default.createElement(OpScheduleCard, { key: schedule.id, opSchedule: schedule, isSelected: selectedId === schedule.id, onClick: handleOnClick(schedule) })))));
    }, [handleClear, handleOnClick, sortedSchedules, selectedId]);
}
exports.CalendarScheduleList = CalendarScheduleList;
exports.default = CalendarScheduleList;
const OpScheduleCard = react_1.default.memo((props) => {
    const { opSchedule, isSelected = false, onClick } = props;
    const myCss = (0, web_css_1.default)(makeMyCardClasses, [isSelected]);
    const handleClick = (0, react_1.useCallback)(e => {
        e.stopPropagation();
        onClick();
    }, [onClick]);
    return (react_1.default.createElement(Card_1.default, { padding: true, classes: myCss, onClick: handleClick },
        react_1.default.createElement("div", null, (0, calcScheduleTitle_1.default)(opSchedule)),
        react_1.default.createElement("div", null, (0, calcPlaceLabel_1.default)(opSchedule))));
});
function getSortScore(v) {
    return v.dueDate.hours() * 60 + v.dueDate.minutes();
}
